import React, { memo } from 'react'
import { Typography } from '@mui/material'

const Text = ({ label, ...restProps }) => {
  return (
    <Typography variant='body2' color='inherit' {...restProps}>
      {label}
    </Typography>
  )
}

export default memo(Text)
